import React from "react";
import "./_page-5.scss";
import {Form} from "react-bootstrap";
import useVMStore from "../../../../store";

export default function Page5() {
    const name = "page5";

    const {data, setData} = useVMStore();

    const values = ["ArchiCAD", "Revit", "Vectorworks", "Allplan"];

    const [soft, ver] = data[name].split("-");

    function isActive(val: string) {
        return soft === val;
    }

    return (
        <Form>
            <div className="page-5 d-flex flex-wrap justify-content-center">
                {values.map((v) => (
                    <Form.Group className="mb-3 col-6 col-sm-3 position-relative" key={"page_5_" + v}>
                        <Form.Check
                            type="radio"
                            id={"page_5_" + v}
                            className={(isActive(v) ? "active" : "")}
                            label={<span>{v}</span>}
                            value={v}
                            checked={isActive(v)}
                            onChange={() => {
                                setData(v, "page5");
                            }}
                        />
                        <Form.Control
                            type="text"
                            placeholder="Ver"
                            maxLength={3}
                            value={ver || ""}
                            onChange={(e) => setData(soft + "-" + e.target.value, "page5")}
                        />
                    </Form.Group>
                ))}
                {data.page4 && data.page4 === "2D" ? (
                    <Form.Group className="mb-3 col-sm-6 col-12 position-relative">
                        <Form.Check
                            type="radio"
                            id={"page_5_Autocad"}
                            className={"w-100" + (isActive("Autocad") ? " active" : "")}
                            label={"Einfache DWG/DXF & PDF (Autocad)"}
                            value={"Autocad"}
                            checked={isActive("Autocad")}
                            onChange={() => {
                                setData("Autocad", "page5");
                            }}
                        />
                        <Form.Control
                            type="text"
                            placeholder="Ver"
                            maxLength={3}
                            value={ver || ""}
                            onChange={(e) => setData(soft + "-" + e.target.value, "page5")}
                        />
                    </Form.Group>
                ) : (
                    ""
                )}
                <div className="col-sm-6 col-12 pe-3">
                    <Form.Control
                        type="text"
                        className="mb-0"
                        placeholder="Sonstige"
                        style={{padding: "0.5em 2em"}}
                        value={!values.includes(soft) && soft !== "Autocad" ? soft : ""}
                        onFocus={() => setData("", "page5")}
                        onChange={(e) => setData(e.target.value, "page5")}
                    />
                </div>
            </div>
        </Form>
    );
}
